var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_775)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_103_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.96 30.3701C19.684 30.3701 21.08 31.7681 21.08 33.4901V46.8801C21.08 48.6041 19.682 50.0001 17.96 50.0001C16.236 50.0001 14.84 48.6021 14.84 46.8801V33.4921C14.84 31.7681 16.236 30.3701 17.96 30.3701Z",
    fill: "#3DDB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.836 14.2739C10.826 14.3919 10.816 14.5119 10.816 14.6319V34.9159C10.816 37.0979 12.542 38.8539 14.686 38.8539H35.314C37.458 38.8539 39.184 37.0959 39.184 34.9159V14.6339C39.184 14.5139 39.18 14.3919 39.17 14.2759L10.836 14.2739Z",
    fill: "#3DDB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.04 30.3699C33.764 30.3699 35.16 31.7679 35.16 33.4899V46.8799C35.16 48.6039 33.762 49.9999 32.04 49.9999C30.316 49.9999 28.92 48.6019 28.92 46.8799V33.4919C28.92 31.7679 30.316 30.3699 32.04 30.3699ZM5.802 16.0799C7.526 16.0799 8.922 17.4779 8.922 19.1999V32.5879C8.922 34.3119 7.524 35.7079 5.802 35.7079C4.078 35.7079 2.682 34.3099 2.682 32.5879V19.1999C2.68 17.4779 4.078 16.0799 5.802 16.0799ZM44.198 16.0799C45.922 16.0799 47.318 17.4779 47.318 19.1999V32.5879C47.318 34.3119 45.92 35.7079 44.198 35.7079C42.474 35.7079 41.078 34.3099 41.078 32.5879V19.1999C41.078 17.4779 42.476 16.0799 44.198 16.0799ZM10.926 12.9419C11.012 6.71193 16.45 1.60393 23.432 0.929932H26.568C33.548 1.60393 38.986 6.71193 39.074 12.9419H10.926Z",
    fill: "#3DDB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.012 0.327881L15.304 6.02988M37.988 0.327881L34.696 6.02988",
    stroke: "#3DDB85",
    strokeWidth: 0.65744,
    strokeMiterlimit: 43.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.808 7.35808C20.81 8.22808 20.09 8.93608 19.198 8.94008C18.306 8.94208 17.582 8.23808 17.578 7.36808V7.36008C17.576 6.48808 18.296 5.78208 19.188 5.77808C20.08 5.77608 20.804 6.48008 20.808 7.35008V7.35808ZM32.86 7.35808C32.862 8.22808 32.142 8.93608 31.25 8.94008C30.358 8.94208 29.634 8.23808 29.63 7.36808V7.36008C29.628 6.48808 30.348 5.78208 31.24 5.77808C32.132 5.77608 32.856 6.48008 32.86 7.35008V7.35808Z",
    fill: "#303030"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_103_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.64,
    height: 50,
    fill: "white",
    transform: "translate(2.68)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.486566f7d4e8bfc4b446225c9242ce54.svg";
export { ForwardRef as ReactComponent };